import React from 'react';
import { TeContainer, TeText } from '@topcon/tuicl-react';

import type { ErrorExplainerContent } from '../../utils/problemDetails.types';
import ErrorExplanationBody from './ErrorExplanationBody';

interface ErrorExplainerProps {
  readonly code: string;
  readonly content: ErrorExplainerContent;
}

/**
 * Error drawer content: a header with the code and resolved title, followed by
 * the shared explanation body (description and steps to resolve). The caller
 * resolves and passes the content.
 * @param props - The error code and its resolved content.
 * @returns The drawer error explainer view.
 */
function ErrorExplainer({ code, content }: ErrorExplainerProps): React.JSX.Element {
  return (
    <TeContainer column gap="m" padding="l">
      <TeText size={20} weight={700}>
        {`${code} - ${content.title}`}
      </TeText>

      <ErrorExplanationBody content={content} />
    </TeContainer>
  );
}

export default ErrorExplainer;
